module.exports = __webpack_public_path__ + "static/img/padewm.52642ba.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/padewm.png
// module id = NkCh
// module chunks = 10